<!-- coherecommandr.component.html -->
<div class="coherecommandr-dialog">
  <button class="close-btn" (click)="close()" aria-label="Close dialog">×</button>

  <div class="header">
    <img src="assets/r.svg" alt="Cohere Logo" class="mini-logo" />
    <h2>Cohere&nbsp;Command&nbsp;R</h2>
    <div class="sub">Grounded enterprise assistant — reliable, structured, and retrieval-friendly</div>
  </div>

  <div class="body">
    <p>
      <strong>Cohere Command R</strong> is an instruction-tuned enterprise model designed for grounded,
      business-friendly outputs. It excels when accuracy, consistency, and “use the provided context”
      behavior matters — especially when paired with retrieval (RAG) from documents, knowledge bases,
      and internal systems.
    </p>

    <ul>
      <li><strong>Grounded answers:</strong> prioritizes supplied context and avoids drifting into unsupported claims.</li>
      <li><strong>RAG-first behavior:</strong> strong fit for retrieval pipelines (docs → context → answer) with clean synthesis.</li>
      <li><strong>Business tone:</strong> professional writing style for customer-facing and internal communications.</li>
      <li><strong>Structured outputs:</strong> great for bullet summaries, action items, classifications, and formatted responses.</li>
      <li><strong>Operational reliability:</strong> consistent instruction following for repeatable production workflows.</li>
    </ul>

    <div class="optimal">
      <h3>What it’s best at</h3>
      <ul>
        <li><strong>Knowledge-base Q&amp;A (RAG):</strong> policies, SOPs, product docs, onboarding, and internal wikis.</li>
        <li><strong>Summarization:</strong> long documents, meetings, tickets, emails, and multi-thread conversations.</li>
        <li><strong>Business writing:</strong> customer replies, internal updates, briefs, and executive-ready summaries.</li>
        <li><strong>Extraction &amp; structure:</strong> turning messy text into clean lists, categories, or key fields.</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Best when to use Command&nbsp;R</h3>
      <ul>
        <li>You want answers grounded in provided documents or retrieved sources</li>
        <li>You need consistent, professional tone and structured output</li>
        <li>You’re building a business assistant with repeatable, production-safe behavior</li>
        <li>You need strong summarization, synthesis, and “next steps” generation</li>
        <li>You want a model that plays well with enterprise retrieval pipelines (RAG)</li>
      </ul>
    </div>
  </div>
</div>
